module.exports = __webpack_public_path__ + "img/组 3.5fc1d12f.webp";